
import { Divider } from 'semantic-ui-react';
import ResourceModal from 'app/components/ResourceModal';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import classes from './classes.module.scss';
import { useState } from 'react';

import { userChangePassword } from 'app/services/accounts';
    
const isMobile = window.innerWidth < 960;

const ChangePasswordForm = (props) => {
    const { accountUser, isOpen, onClose } = props;
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const fieldSx = {
        width: '36rem'
    }

    let size = 'large';
    let style = {};
    if (isMobile) {
        style.fontSize = '0.8rem';
    }
    style.textTransform = 'none';
    style.boxShadow = 'none';
    style.background = '#f3f3f8';
    style.color = 'black';
    style.width = '50%';

    const handleChangePassword = () => {
        if (accountUser != null && password === confirmPassword) {
            userChangePassword(password, accountUser.id).then(() => {
                onClose();
                alert('Password changed successfully');
            }).catch((e) => {
                alert(e.error);
            });
        } else {
            alert('Password and confirm password does not match');
        }
    }

    return (
        <ResourceModal {...{ isOpen, onClose, title: 'Change Password' }}>
            <div >
                <TextField id="outlined-basic"
                    label="New Password"
                    variant="outlined"
                    sx={fieldSx}
                    type='password'
                    onChange={(e) => setPassword(e.target.value)} />
                <br />
                <br />
                <TextField id="outlined-basic"
                    label="Confirm Password"
                    variant="outlined"
                    sx={fieldSx}
                    type='password'
                    onChange={(e) => setConfirmPassword(e.target.value)} />
                <br />
                <Divider />
                <div className={classes.buttons}>
                    <Button size={size} style={style} variant='outlined' onClick={onClose}>Cancel</Button>
                    <Button size={size} style={style} variant='outlined' onClick={() => handleChangePassword()}>Save</Button>
                </div>
            </div>
        </ResourceModal>
    )
}

export default ChangePasswordForm